import { html } from "./bind";
import { currentScope } from "./scope";

function eyeToggleButton(): HTMLButtonElement {
  const fragment = html`<button
    type="button"
    class="password-toggle"
    aria-label="Show password"
    aria-pressed="false"
  >
    <svg
      class="icon-eye"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z"></path><circle cx="12" cy="12" r="3"></circle></svg>
    <svg
      class="icon-eye-off"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ><path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.27 21.27 0 0 1 5.06-5.94"></path><path d="M9.9 4.24A10.4 10.4 0 0 1 12 4c7 0 11 7 11 7a21.27 21.27 0 0 1-2.16 3.19"></path><path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"></path><path d="M1 1l22 22"></path></svg>
  </button>`;
  return fragment.firstElementChild as HTMLButtonElement;
}

/**
 * Adds a show/hide eye-button toggle to a password input, inserted via JS so no view's
 * markup needs the button/icons hand-duplicated. Default hidden.
 */
export function addPasswordToggle(input: HTMLInputElement): void {
  // Wrap just the input (not its surrounding .form-field, which also has a label stacked
  // above it) so the toggle button can be positioned relative to the input alone.
  const wrapper = document.createElement("div");
  wrapper.className = "password-field";
  input.replaceWith(wrapper);
  wrapper.appendChild(input);

  const button = eyeToggleButton();
  wrapper.appendChild(button);
  input.classList.add("has-password-toggle");

  const setVisible = (visible: boolean): void => {
    input.type = visible ? "text" : "password";
    button.setAttribute("aria-label", visible ? "Hide password" : "Show password");
    button.setAttribute("aria-pressed", String(visible));
    button.classList.toggle("showing", visible);
  };
  setVisible(false);

  const onClick = (): void => setVisible(input.type === "password");
  button.addEventListener("click", onClick);
  currentScope().cleanup(() => button.removeEventListener("click", onClick));
}
